import markSvg from "@brand/assets/logos/versus-mark-black.svg?raw";

import { tintSvg } from "@/lib/certificate";
import { cn } from "@/lib/utils";

export function BrandMark({
  color = "var(--v-gold)",
  className,
}: {
  color?: string;
  className?: string;
}) {
  return (
    <span
      className={cn("mark inline-block shrink-0", className)}
      style={{ color }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: tintSvg(markSvg, "currentColor") }}
    />
  );
}
